import type { Namespace } from '../types';

// Warehouse + procurement (R-064/R-065). DE drafted — queued for review.
export const erp = {
  whTitle: { de: 'Warehouse', en: 'Warehouse' },
  whDesc: {
    de: 'Artikelstamm, Chargen mit MHD, Bewegungsjournal und Inventur — FEFO bei jeder Entnahme.',
    en: 'Item master, lots with expiry, movement journal and stocktake — FEFO on every issue.',
  },
  procTitle: { de: 'Procurement', en: 'Procurement' },
  procDesc: {
    de: 'Bedarfsanforderungen mit zweistufiger Freigabe, Bestellungen mit Tracking, Lieferantenstamm.',
    en: 'Requisitions with two-stage approval, orders with tracking, supplier master.',
  },

  open: { de: 'Öffnen', en: 'Open' },
  // The item row's stock view — lots plus the receipt/issue postings.
  colActions: { de: 'Aktionen', en: 'Actions' },
  stockAction: { de: 'Bestand', en: 'Stock' },
  tabItems: { de: 'Artikel', en: 'Items' },
  tabMovements: { de: 'Bewegungen', en: 'Movements' },
  tabStocktake: { de: 'Inventur', en: 'Stocktake' },
  tabRequisitions: { de: 'Anforderungen', en: 'Requisitions' },
  tabOrders: { de: 'Bestellungen', en: 'Orders' },
  tabSuppliers: { de: 'Lieferanten', en: 'Suppliers' },

  // Categories
  catFertilizer: { de: 'Dünger', en: 'Fertilizer' },
  catSeed: { de: 'Saatgut', en: 'Seed' },
  catSubstrate: { de: 'Substrat', en: 'Substrate' },
  catConsumable: { de: 'Verbrauchsmaterial', en: 'Consumable' },
  catSparePart: { de: 'Ersatzteil', en: 'Spare part' },

  // Stock status (derived)
  stInStock: { de: 'Auf Lager', en: 'In stock' },
  stLow: { de: 'Niedrig', en: 'Low' },
  stOut: { de: 'Leer', en: 'Out of stock' },

  // Items tab
  colSku: { de: 'SKU', en: 'SKU' },
  colItem: { de: 'Artikel', en: 'Item' },
  colCategory: { de: 'Kategorie', en: 'Category' },
  colOnHand: { de: 'Bestand', en: 'On hand' },
  colMinStock: { de: 'Mindestbestand', en: 'Min stock' },
  colStatus: { de: 'Status', en: 'Status' },
  newItem: { de: 'Neuer Artikel', en: 'New Item' },
  editItem: { de: 'Artikel bearbeiten', en: 'Edit item' },
  itemName: { de: 'Name', en: 'Name' },
  unit: { de: 'Einheit', en: 'Unit' },
  supplier: { de: 'Lieferant', en: 'Supplier' },
  notes: { de: 'Notizen', en: 'Notes' },
  selectOption: { de: 'Wählen…', en: 'Select…' },
  itemsEmpty: {
    de: 'Noch keine Artikel — „Neuer Artikel" legt den ersten an.',
    en: 'No items yet — "New item" creates the first one.',
  },
  toastItemSaved: { de: 'Artikel gespeichert', en: 'Item saved' },
  deleteItemTitle: { de: '{sku} löschen?', en: 'Delete {sku}?' },
  deleteItemMsg: {
    de: 'Nur möglich ohne Bestände/Bewegungen (Journal bleibt geschützt).',
    en: 'Only possible without stock/movements (the journal stays protected).',
  },
  toastItemDeleted: { de: 'Artikel gelöscht', en: 'Item deleted' },

  // Item detail / postings
  lots: { de: 'Chargen', en: 'Lots' },
  lotCode: { de: 'Charge', en: 'Lot' },
  expiry: { de: 'MHD', en: 'Expiry' },
  quantity: { de: 'Menge', en: 'Quantity' },
  noLots: { de: 'Kein Bestand.', en: 'No stock.' },
  postReceipt: { de: 'Wareneingang', en: 'Receipt' },
  postConsumption: { de: 'Entnahme', en: 'Issue' },
  warehouse: { de: 'Lager', en: 'Warehouse' },
  note: { de: 'Notiz', en: 'Note' },
  post: { de: 'Buchen', en: 'Post' },
  toastPosted: { de: 'Buchung erfasst', en: 'Posting recorded' },
  fefoHint: {
    de: 'Entnahme verbraucht automatisch die Charge mit dem frühesten MHD zuerst (FEFO).',
    en: 'Issue automatically drains the earliest-expiry lot first (FEFO).',
  },

  // Movements tab
  colKind: { de: 'Art', en: 'Kind' },
  colQty: { de: 'Menge', en: 'Qty' },
  colRef: { de: 'Referenz', en: 'Reference' },
  colWhen: { de: 'Zeitpunkt', en: 'When' },
  mvReceipt: { de: 'Wareneingang', en: 'Receipt' },
  mvConsumption: { de: 'Entnahme', en: 'Issue' },
  mvCorrection: { de: 'Korrektur', en: 'Correction' },
  mvTransferIn: { de: 'Umlagerung (ein)', en: 'Transfer in' },
  mvTransferOut: { de: 'Umlagerung (aus)', en: 'Transfer out' },
  mvStocktake: { de: 'Inventur', en: 'Stocktake' },
  movementsEmpty: { de: 'Noch keine Bewegungen.', en: 'No movements yet.' },

  // Stocktake tab
  counted: { de: 'Gezählte Menge', en: 'Counted quantity' },
  stocktakeHint: {
    de: 'Die Differenz zum Buchbestand wird als Inventur-Buchung erfasst (Journal).',
    en: 'The difference to book stock is posted as a stocktake movement (journal).',
  },
  toastStocktake: { de: 'Inventur gebucht — Differenz {diff}', en: 'Stocktake posted — difference {diff}' },
  stocktakeTitle: { de: 'Inventurzählung buchen', en: 'Post a stocktake count' },

  // Field placeholders (Warehouse forms)
  phSku: { de: 'z. B. FERT-001', en: 'e.g. FERT-001' },
  phItemName: { de: 'z. B. Calciumnitrat 25 kg', en: 'e.g. Calcium nitrate 25 kg' },
  phCategory: { de: 'Kategorie wählen', en: 'Select a category' },
  phUnit: { de: 'Einheit wählen', en: 'Select a unit' },
  phMinStock: { de: 'z. B. 10', en: 'e.g. 10' },
  phSupplier: { de: 'Lieferant wählen (optional)', en: 'Select a supplier (optional)' },
  phNotes: { de: 'Lagerung, Handhabung, Hinweise…', en: 'Storage, handling, remarks…' },
  phWarehouse: { de: 'Lager wählen', en: 'Select a warehouse' },
  phItem: { de: 'Artikel wählen', en: 'Select an item' },
  phQuantity: { de: 'z. B. 25', en: 'e.g. 25' },
  phLot: { de: 'z. B. LOT-2026-09', en: 'e.g. LOT-2026-09' },
  phNote: { de: 'Optionale Notiz', en: 'Optional note' },
  phCounted: { de: 'Physisch gezählte Menge', en: 'Quantity physically counted' },

  // Requisitions
  colNumber: { de: 'Nummer', en: 'Number' },
  colWhat: { de: 'Artikel / Asset-Typ', en: 'Item / asset type' },
  colRequester: { de: 'Angefordert', en: 'Requested' },
  prPendingFunctional: { de: 'Fachliche Freigabe', en: 'Functional approval' },
  prPendingCommercial: { de: 'Kommerzielle Freigabe', en: 'Commercial approval' },
  prPendingMd: { de: 'GF-Freigabe', en: 'MD approval' },
  prPendingCeo: { de: 'CEO-Freigabe', en: 'CEO approval' },
  prApproved: { de: 'Freigegeben', en: 'Approved' },
  capitalBadge: { de: 'Investition', en: 'Capital' },
  warrantyMonths: { de: 'Garantie (Monate)', en: 'Warranty (months)' },
  warrantyMonthsHint: {
    de: 'Wird auf die Bestellposition übernommen (optional).',
    en: 'Carried onto the PO line (optional).',
  },
  prRejected: { de: 'Abgelehnt', en: 'Rejected' },
  prCancelled: { de: 'Storniert', en: 'Cancelled' },
  autoBadge: { de: 'Auto', en: 'Auto' },
  openOnly: { de: 'Nur offene', en: 'Open only' },
  newPr: { de: 'Neue Anforderung', en: 'New requisition' },
  approve: { de: 'Freigeben', en: 'Approve' },
  reject: { de: 'Ablehnen', en: 'Reject' },
  // R147-3A (A-1): the supplier-pick dialog now opens on the FINAL approval
  // (MD below AED 20k, else CEO) — commercial no longer finalises.
  approveCommercialTitle: {
    de: '{number} final freigeben (Lieferant wählen)',
    en: 'Final approval for {number} (pick supplier)',
  },
  supplierRequired: {
    de: 'Bestellung geht an (freigegebener Lieferant):',
    en: 'Order goes to (approved supplier):',
  },
  needBy: { de: 'Benötigt bis', en: 'Need by' },
  costCenter: { de: 'Kostenstelle', en: 'Cost center' },
  justification: { de: 'Begründung', en: 'Justification' },
  stockItem: { de: 'Lagerartikel', en: 'Stock item' },
  assetType: { de: 'Asset-Typ', en: 'Asset type' },
  prsEmpty: { de: 'Keine Anforderungen.', en: 'No requisitions.' },
  toastPrCreated: { de: '{number} angelegt', en: '{number} created' },
  toastDecided: { de: 'Entscheidung erfasst', en: 'Decision recorded' },
  toastPoCreated: { de: 'Bestellung {number} erstellt', en: 'Order {number} created' },

  // Orders
  colSupplier: { de: 'Lieferant', en: 'Supplier' },
  colTracking: { de: 'Tracking', en: 'Tracking' },
  colEta: { de: 'ETA', en: 'ETA' },
  poOpen: { de: 'Offen', en: 'Open' },
  poShipped: { de: 'Versandt', en: 'Shipped' },
  poReceived: { de: 'Eingegangen', en: 'Received' },
  poCancelled: { de: 'Storniert', en: 'Cancelled' },
  shipping: { de: 'Versand', en: 'Shipping' },
  carrier: { de: 'Carrier', en: 'Carrier' },
  receive: { de: 'Wareneingang', en: 'Receive' },
  receiveTitle: { de: '{number} Wareneingang buchen', en: 'Receive {number}' },
  receiveItemHint: {
    de: 'Der Bestand wird im gewählten Lager als neue Charge gebucht.',
    en: 'Stock is posted into the chosen warehouse as a new lot.',
  },
  receiveAssetHint: {
    de: 'Asset-Typ-Bestellung: Einheiten werden mit Seriennummern im Asset Lifecycle erfasst.',
    en: 'Asset-type order: units are registered with serials in Asset Lifecycle.',
  },
  ordersEmpty: { de: 'Keine Bestellungen.', en: 'No orders.' },
  toastShipping: { de: 'Versanddaten gespeichert', en: 'Shipping saved' },
  toastReceived: { de: '{number} eingegangen', en: '{number} received' },

  // PO lines (R-145)
  viewLines: { de: 'Positionen', en: 'Lines' },
  poLinesTitle: { de: 'Bestellpositionen {number}', en: 'Order lines {number}' },
  colLineNo: { de: 'Pos.', en: 'Line' },
  colDesc: { de: 'Beschreibung', en: 'Description' },
  colUnitPrice: { de: 'Einzelpreis', en: 'Unit price' },
  colWarrantyMonths: { de: 'Garantie (Mon.)', en: 'Warranty (mo.)' },
  colReceivedQty: { de: 'Erhalten', en: 'Received' },
  colTarget: { de: 'Artikel / Klasse', en: 'Item / class' },
  linesEmpty: { de: 'Keine Positionen.', en: 'No lines.' },

  // Suppliers
  colLeadTime: { de: 'Lieferzeit (Tage)', en: 'Lead time (days)' },
  colApproved: { de: 'Freigegeben', en: 'Approved' },
  colRating: { de: 'Bewertung', en: 'Rating' },
  newSupplier: { de: 'Neuer Lieferant', en: 'New supplier' },
  editSupplier: { de: 'Lieferant bearbeiten', en: 'Edit supplier' },
  contact: { de: 'Kontakt', en: 'Contact' },
  terms: { de: 'Konditionen', en: 'Terms' },
  approvedFlag: { de: 'Freigegebener Lieferant', en: 'Approved supplier' },
  approvedHint: {
    de: 'Nur freigegebene Lieferanten erhalten Bestellungen (ERP-P-007).',
    en: 'Only approved suppliers receive orders (ERP-P-007).',
  },
  suppliersEmpty: { de: 'Keine Lieferanten.', en: 'No suppliers.' },
  toastSupplierSaved: { de: 'Lieferant gespeichert', en: 'Supplier saved' },

  // K-1 / K-2: PR record surface (approval trail + PO ref) and amount capture.
  colAmount: { de: 'Betrag (geschätzt)', en: 'Amount (est.)' },
  amountEstimate: { de: 'Geschätzter Betrag (AED)', en: 'Estimated amount (AED)' },
  amountEstimateHint: {
    de: 'Steuert die wertabhängige Freigabekette (MD immer; CEO zusätzlich ab 20k).',
    en: 'Drives the value-gated approval chain (MD always; CEO also from 20k).',
  },
  approvalTrail: { de: 'Freigabekette', en: 'Approval trail' },
  stageFunctional: { de: 'Fachlich', en: 'Functional' },
  stageCommercial: { de: 'Kaufmännisch', en: 'Commercial' },
  stageMd: { de: 'MD', en: 'MD' },
  stageCeo: { de: 'CEO', en: 'CEO' },
  stageDecided: { de: 'Entschieden', en: 'Decided' },
  stageCurrent: { de: 'Aktuelle Stufe', en: 'Current stage' },
  stageNotReached: { de: '— nicht erreicht —', en: '— not reached —' },
  poRef: { de: 'Bestellung (PO)', en: 'Purchase order' },
  poNotCreated: { de: 'Noch keine PO erstellt', en: 'No PO created yet' },
  poTotal: { de: 'PO-Summe', en: 'PO total' },
  // K-4: ship-to on the PO (deliverTo/deliverToHint already defined above).
  shipTo: { de: 'Versandadresse', en: 'Ship to' },
  shipToHint: { de: 'Lieferadresse für diese Bestellung.', en: 'Delivery address for this order.' },
  deliverTo: { de: 'Lieferziel', en: 'Deliver to' },
  deliverToHint: {
    de: 'Zielort/Lager für die Lieferung (z. B. VFU01 Laydown).',
    en: 'Destination/stockroom for the delivery (e.g. VFU01 Laydown).',
  },
} as const satisfies Namespace;
